module.exports = __webpack_public_path__ + "img/EMT-LICA_GSE236681.26d8b1c7.png";